// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal[data-v-56d65717]{background-color:rgba(0,0,0,.5)}.close[data-v-56d65717]{top:14px;right:20px}button[data-v-56d65717]{margin-bottom:30px}", ""]);
// Exports
module.exports = exports;
